import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { notifications } from "data/actions";
import MenuLink from "components/Navigation/MenuLink";

import {
  Page,
  PageSection,
  PageBlock,
  RightDrawer
} from "components/Page";
import Price from "components/Formaters/Price";
import Delete from "components/Buttons/Delete";
import * as os from "osutil";

import Subheader from "material-ui/Subheader";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow
} from "material-ui/Table";
import ClickableRowColumn from "components/Grid/ClickableRowColumn";
import ClickableRow from "components/Grid/ClickableRow";

import FloatingActionButton from "material-ui/FloatingActionButton";
import ContentAdd from "material-ui/svg-icons/content/add";

class NotificationsPage extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.actions.fetchNotifications(this.props.user.accountid);
  }

  handleEditClick = key => {
    this.context.router.history.push(
      `/meddelande/${this.props.user.accountid}/${key}`
    );
  };

  renderNotifications = notifications => {
    return _.map(notifications, (notification, key) => {
      var count = 0,
        price = 0,
        date = 0;
      var description = "";
      var created = notification.created
        ? os.formatDateTime(notification.created)
        : "";

      return (
        <ClickableRow
          className={notification.read ? "read" : "unread"}
          key={notification.key}
          onMyRowClick={() => this.handleEditClick(notification.key)}
        >
          <ClickableRowColumn>{created}</ClickableRowColumn>
          <ClickableRowColumn>{notification.subject}</ClickableRowColumn>
          <ClickableRowColumn>
            {notification.body.substring(0, 50)}
          </ClickableRowColumn>
        </ClickableRow>
      );
    });
  };
  render() {
    var { notifications } = this.props;
    return [
      <RightDrawer key="brand_right">
        <PageBlock label="Översikt">
          <div>
            <div>
              Meddelanden: <b>{notifications.length}</b>
            </div>
            <div>
              Olästa meddelanden: <b>{notifications.filter(n => n.read).length}</b>
            </div>
          </div>
        </PageBlock>
        </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <PageBlock header={true} label="Meddelanden">
          {!notifications || notifications.length === 0 ? (
            <span>Inga meddelanden</span>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHeaderColumn>Datum</TableHeaderColumn>
                  <TableHeaderColumn>Ämne</TableHeaderColumn>
                  <TableHeaderColumn>Meddelanden</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody>{this.renderNotifications(notifications)}</TableBody>
            </Table>
          )}
        </PageBlock>
        
      </Page>
    ];
  }
}

function mapStateToProps(state) {
  var list = os.collection_to_array(state.notifications.list.data);
  list = list.sort(t => t.created).filter(t => !t.deleted).sort(function(a, b) {
    return b.created - a.created;
  });
  return {
    notifications: list,
    count: list.length,
    user: state.auth.user,
    pending: state.notifications.list.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...notifications }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch)(NotificationsPage);



// WEBPACK FOOTER //
// ./src/pages/notifications/Notifications.jsx